// extracted by mini-css-extract-plugin
export default {"loading_messages_fallback":"loadingMessages_loading_messages_fallback__Tptm5"};